import { render, staticRenderFns } from "./WidgetAccessKeyPage.vue?vue&type=template&id=2a4716a8&scoped=true&"
import script from "./WidgetAccessKeyPage.vue?vue&type=script&lang=js&"
export * from "./WidgetAccessKeyPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a4716a8",
  null
  
)

export default component.exports